import { makeStyles } from '@material-ui/core';
import React from 'react';

export interface baseContainerProps {
  title: string;
  subTitle: React.ReactNode;
}
const useStyles = makeStyles({
  title: {
    fontWeight: 700,
    color: '#05164d',
    fontSize: '20px',
  },
  subTitle: {
    color: 'grey',
  },
  application: {
    color: 'grey',
    fontWeight: 300,
  },
});

const BaseContainer = ({ title, subTitle }: baseContainerProps) => {
  const styles = useStyles();
  return (
    <div>
      <section className={styles.title}>{title}</section>
      <p className={`${styles.subTitle}`}>{subTitle}</p>
    </div>
  );
};

export { BaseContainer };
